import * as ng from 'angular';
import * as _ from 'underscore';

ng.module('e360')
   .directive('guestTypePicker', guestTypePickerDirective);

import { GuestType, GuestTypeService } from './';

interface GuestTypeDropdownItem extends GuestType {
   selected:boolean;
}

export class GuestTypePickerController implements ng.IController {
   static $inject = ['GuestTypeService', 'session', '$scope'];

   isSearch:boolean;
   property:string = 'id';

   ngModel:ng.INgModelController;

   guestTypes:GuestTypeDropdownItem[];
   isOpen:boolean;

   constructor(
      private guestTypeService:GuestTypeService,
      private session,
      private $scope:ng.IScope
   ) { }

   $onInit() {
      this.guestTypeService.list(this.session.getCampaign().id)
         .then(guestTypes => this.onLoad(guestTypes))
         .then(() => {
            // model value will be sent through formatter before load finishes
            // call this method to initialize selected guest types
            this.onValueChange(this.ngModel.$modelValue);
         });

      if (this.isSearch) {
         this.property = 'slug';
      }

      this.ngModel.$parsers.push((value:string) => {
         if (this.isSearch) {
            value = this.applySearch(value);
         }

         return value;
      });

      this.ngModel.$formatters.push((value) => {
         return this.onValueChange(value);
      });
   }

   get buttonLabel():string {
      let selected = _.filter(this.guestTypes, g => g.selected);
      if (selected.length > 0) {
         return `${selected.length} Types Selected`;
      } else {
         return 'Select Guest Types';
      }
   }

   onToggle(open:boolean) {
      if (!open) {
         this.commit();
      }
   }

   onSelect(guestType:GuestTypeDropdownItem) {
      guestType.selected = !guestType.selected;
   }

   onClear() {
      for (let guestType of this.guestTypes) {
         guestType.selected = false;
      }

      this.commit();
      this.isOpen = false;
   }

   private commit() {
      let values = _.chain(this.guestTypes)
         .filter(g => g.selected)
         .pluck(this.property)
         .value();

      this.ngModel.$setViewValue(values.join(','));
   }

   private onLoad(guestTypes:GuestType[]) {
      this.guestTypes = _.map(guestTypes, (g) => {
         let item = g as GuestTypeDropdownItem;
         item.selected = false;
         return item;
      });

      // internally the directive tracks general guest type as slug '$'
      // so that we can differentiate between no guests types (empty/null value)
      // and when just general guest type is selected
      this.guestTypes.unshift({
         id: 0, campaignId: null, settings: null,
         name: 'General',
         slug: '$',
         selected: false
      });
   }

   private onValueChange(value:string) {
      let values:string[] = [];

      // split CSV value and replace empty with $
      function split(value:string) {
         return _.map(value.split(','), s => s === '' ? '$' : s);
      }

      if (ng.isString(value)) {
         if (this.isSearch) {
            var match = value.match(/type:([^ ]*)/);
            if (match) {
               values = split(match[1])
            }
         } else {
            values = split(value);
         }
      }

      if (this.guestTypes) {
         for (let g of this.guestTypes) {
            g.selected = _.any(values, (v) => v == g[this.property]);
         }
      }

      return values.join(',');
   }

   private applySearch(value:string):string {
      let search = this.ngModel.$modelValue;

      if (value.length == 0) {
         if (ng.isString(search)) {
            search = search.replace(/type:[^ ]*/, '');
         }
      } else {
         // replace general guest type '$' with empty value when inserting
         // back into search string
         value = value.replace('$', '');

         if (ng.isString(search) && search !== '') {
            if (search.indexOf('type:') >= 0) {
               search = search.replace(/type:[^ ]*/, `type:${value}`);
            } else {
               search = `${search} type:${value}`
            }
         } else {
            search = `type:${value}`;
         }
      }

      return search;
   }
}

const templateUrl = require('./guest-type-picker.directive.html');

function guestTypePickerDirective():ng.IDirective {
   return {
      templateUrl: templateUrl,
      controller: GuestTypePickerController,
      controllerAs: '$ctrl',
      require: { ngModel: '' },
      scope: { isSearch: '@' },
      bindToController: true
   };
}
